/* eslint-disable no-console */
import { register } from 'register-service-worker'
import axios from 'axios'

// Solo registrar en producción o localhost
if (process.env.NODE_ENV === 'production' || window.location.hostname === 'localhost') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      //console.log('✅ App is being served from cache by a service worker.')
    },
    registered () {
      //registration
      //console.log('🛠️ Service worker has been registered.')

      // Inicializar suscripción push solo si hay sesión activa
      //inicializarPush(registration)
    },
    cached () {
      //console.log('📦 Content has been cached for offline use.')
    },
    updatefound () {
      //console.log('🔄 New content is downloading.')
    },
    updated () {
      //console.log('✨ New content is available; please refresh.')
    },
    offline () {
      //console.log('📴 No internet connection. App is running in offline mode.')
    },
    error (error) {
      console.error('❌ Error during service worker registration:', error)
    }
  })
}

// 👉 Función para inicializar la suscripción push
export async function inicializarPush(registration) {
  const token = localStorage.getItem('token')
  if (!token) {
    //console.log('⛔ No hay sesión activa. No se registra push.')
    return
  }

  if (!('PushManager' in window)) {
    //console.warn('⚠️ Push no soportado en este navegador.')
    return
  }

  const permiso = await Notification.requestPermission()
  if (permiso !== 'granted') {
    //console.warn('🔒 Permiso de notificación denegado.')
    return
  }

  const existente = await registration.pushManager.getSubscription()

  if (existente) {
    //console.log('📌 Ya estás suscrito. Validando con el backend...')

    const payload = {
      endpoint: existente.endpoint,
      p256dh: btoa(String.fromCharCode(...new Uint8Array(existente.getKey('p256dh')))),
      auth: btoa(String.fromCharCode(...new Uint8Array(existente.getKey('auth'))))
    }

    try {
      await axios.post(`${process.env.VUE_APP_BASE_API}push/save-subscription`, payload, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      })

      //console.log('✅ Suscripción validada con el backend.')
      return
    } catch (error) {
      //console.warn('❌ Suscripción rechazada por backend. Eliminando y recreando...', error.message)
      await existente.unsubscribe()
    }
  }

  // 👉 Crear nueva suscripción
  const publicKey = process.env.VUE_APP_PUBLIC_VAPID_KEY
  const nuevaSubscripcion = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey)
  })

  //console.log('🆕 Nueva suscripción creada:', nuevaSubscripcion)

  const payload = {
    endpoint: nuevaSubscripcion.endpoint,
    p256dh: btoa(String.fromCharCode(...new Uint8Array(nuevaSubscripcion.getKey('p256dh')))),
    auth: btoa(String.fromCharCode(...new Uint8Array(nuevaSubscripcion.getKey('auth'))))
  }

  await axios.post(`${process.env.VUE_APP_BASE_API}push/save-subscription`, payload, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })

  //console.log('📬 Nueva suscripción enviada al backend.')
}

// 🔧 Función auxiliar para convertir la clave pública
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/')
  const rawData = window.atob(base64)
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)))
}
